import React, { ReactNode } from 'react'

import sortBy from 'lodash/sortBy'

import { PLATFORM } from './enums'
import {
  forceLoginUrlFacebook,
  forceLoginUrlGoogle,
  forceLoginUrlInstagram,
  forceLoginUrlLinkedin,
  forceLoginUrlReddit,
  forceLoginUrlStrava,
  forceLoginUrlTwitter,
  forceLoginUrlVenmo,
  forceLoginUrlYoutube,
  loginUrlFacebook,
  loginUrlGoogle,
  loginUrlInstagram,
  loginUrlLinkedIn,
  loginUrlReddit,
  loginUrlStrava,
  loginUrlTwitter,
  loginUrlVenmo,
  loginUrlYoutube,
  platformUrlBluesky,
  platformUrlFacebook,
  platformUrlGoogle,
  platformUrlInstagram,
  platformUrlLinkedin,
  platformUrlReddit,
  platformUrlSnapchat,
  platformUrlStrava,
  platformUrlTiktok,
  platformUrlTwitter,
  platformUrlVenmo,
  platformUrlYoutube,
} from '../consts/urlConsts'
import PlatformLogoBluesky from '../icons/platform-logo-bluesky.svg'
import PlatformLogoFacebook from '../icons/platform-logo-facebook.svg'
import PlatformLogoGoogle from '../icons/platform-logo-google.svg'
import PlatformLogoInstagram from '../icons/platform-logo-instagram.svg'
import PlatformLogoLinkedin from '../icons/platform-logo-linkedin.svg'
import PlatformLogoReddit from '../icons/platform-logo-reddit.svg'
import PlatformLogoSnapchat from '../icons/platform-logo-snapchat.svg'
import PlatformLogoStrava from '../icons/platform-logo-strava.svg'
import PlatformLogoTiktok from '../icons/platform-logo-tiktok.svg'
import PlatformLogoTwitter from '../icons/platform-logo-twitter.svg'
import PlatformLogoVenmo from '../icons/platform-logo-venmo.svg'
import PlatformLogoYoutube from '../icons/platform-logo-youtube.svg'

export function getLogoFromPlatform(
  platform: PLATFORM,
  logoClassName = '',
): ReactNode {
  const mapPlatformToLogo: Record<PLATFORM, ReactNode> = {
    [PLATFORM.BLUESKY]: (
      <PlatformLogoBluesky aria-hidden className={logoClassName} />
    ),
    [PLATFORM.FACEBOOK]: (
      <PlatformLogoFacebook aria-hidden className={logoClassName} />
    ),
    [PLATFORM.GOOGLE]: (
      <PlatformLogoGoogle aria-hidden className={logoClassName} />
    ),
    [PLATFORM.INSTAGRAM]: (
      <PlatformLogoInstagram aria-hidden className={logoClassName} />
    ),
    [PLATFORM.LINKEDIN]: (
      <PlatformLogoLinkedin aria-hidden className={logoClassName} />
    ),
    [PLATFORM.REDDIT]: (
      <PlatformLogoReddit aria-hidden className={logoClassName} />
    ),
    [PLATFORM.TWITTER]: (
      <PlatformLogoTwitter aria-hidden className={logoClassName} />
    ),
    [PLATFORM.TIKTOK]: (
      <PlatformLogoTiktok aria-hidden className={logoClassName} />
    ),
    [PLATFORM.SNAPCHAT]: (
      <PlatformLogoSnapchat aria-hidden className={logoClassName} />
    ),
    [PLATFORM.STRAVA]: (
      <PlatformLogoStrava aria-hidden className={logoClassName} />
    ),
    [PLATFORM.VENMO]: (
      <PlatformLogoVenmo aria-hidden className={logoClassName} />
    ),
    [PLATFORM.YOUTUBE]: (
      <PlatformLogoYoutube aria-hidden className={logoClassName} />
    ),
  }
  return mapPlatformToLogo[platform]
}

export function getPlatformForceLoginUrl(
  platform: PLATFORM,
): string | undefined {
  const mapPlatformToUrl: Record<PLATFORM, string> = {
    [PLATFORM.BLUESKY]: undefined,
    [PLATFORM.FACEBOOK]: forceLoginUrlFacebook,
    [PLATFORM.GOOGLE]: forceLoginUrlGoogle,
    [PLATFORM.INSTAGRAM]: forceLoginUrlInstagram,
    [PLATFORM.LINKEDIN]: forceLoginUrlLinkedin,
    [PLATFORM.REDDIT]: forceLoginUrlReddit,
    [PLATFORM.SNAPCHAT]: undefined,
    [PLATFORM.STRAVA]: forceLoginUrlStrava,
    [PLATFORM.TIKTOK]: undefined,
    [PLATFORM.TWITTER]: forceLoginUrlTwitter,
    [PLATFORM.VENMO]: forceLoginUrlVenmo,
    [PLATFORM.YOUTUBE]: forceLoginUrlYoutube,
  }
  return mapPlatformToUrl[platform]
}

export function getPlatformLoginUrl(platform: PLATFORM): string | undefined {
  const mapPlatformToUrl: Record<PLATFORM, string> = {
    [PLATFORM.BLUESKY]: undefined,
    [PLATFORM.FACEBOOK]: loginUrlFacebook,
    [PLATFORM.GOOGLE]: loginUrlGoogle,
    [PLATFORM.INSTAGRAM]: loginUrlInstagram,
    [PLATFORM.LINKEDIN]: loginUrlLinkedIn,
    [PLATFORM.REDDIT]: loginUrlReddit,
    [PLATFORM.SNAPCHAT]: undefined,
    [PLATFORM.STRAVA]: loginUrlStrava,
    [PLATFORM.TIKTOK]: undefined,
    [PLATFORM.TWITTER]: loginUrlTwitter,
    [PLATFORM.VENMO]: loginUrlVenmo,
    [PLATFORM.YOUTUBE]: loginUrlYoutube,
  }
  return mapPlatformToUrl[platform]
}

export function getPlatformUrl(platform: PLATFORM): string {
  const mapPlatformToUrl: Record<PLATFORM, string> = {
    [PLATFORM.BLUESKY]: platformUrlBluesky,
    [PLATFORM.FACEBOOK]: platformUrlFacebook,
    [PLATFORM.GOOGLE]: platformUrlGoogle,
    [PLATFORM.INSTAGRAM]: platformUrlInstagram,
    [PLATFORM.LINKEDIN]: platformUrlLinkedin,
    [PLATFORM.REDDIT]: platformUrlReddit,
    [PLATFORM.STRAVA]: platformUrlStrava,
    [PLATFORM.SNAPCHAT]: platformUrlSnapchat,
    [PLATFORM.TIKTOK]: platformUrlTiktok,
    [PLATFORM.TWITTER]: platformUrlTwitter,
    [PLATFORM.VENMO]: platformUrlVenmo,
    [PLATFORM.YOUTUBE]: platformUrlYoutube,
  }
  return mapPlatformToUrl[platform]
}

export function getSortedPlatforms(unsortedPlatforms: PLATFORM[]): PLATFORM[] {
  return sortBy(unsortedPlatforms, (p) =>
    [
      PLATFORM.TWITTER,
      PLATFORM.BLUESKY,
      PLATFORM.LINKEDIN,
      PLATFORM.VENMO,
      PLATFORM.FACEBOOK,
      PLATFORM.INSTAGRAM,
      PLATFORM.REDDIT,
      PLATFORM.GOOGLE,
      PLATFORM.YOUTUBE,
      PLATFORM.STRAVA,
      PLATFORM.TIKTOK,
      PLATFORM.SNAPCHAT,
    ].indexOf(p),
  )
}
